import { Component, Input, ViewChild } from '@angular/core';
import { TransactionFacade } from '../../../models/transactions/transactionFacade';
import { TableView } from '../../ui/filterable-table/tableView';
import { TransactionTableViewComponent } from '../../transaction/transaction-table-view/transaction-table-view.component';
import { AccessManager } from '../../ui/access-manager/access-manager';
import { Options } from '../../ui/filterable-table/options';

@Component({
  selector: 'app-merchant-transactions',
  templateUrl: './merchant-transactions.component.html',
  standalone: false,
})
export class MerchantTransactionsComponent {
  @Input() merchantId: string | undefined;
  @Input() numberOfLocationMIDs: number = 0;
  @Input() hideMID: boolean = false;

  @ViewChild('transactionsTable') transactionsTableControl:
    | TransactionTableViewComponent
    | undefined;

  tableView: any;
  selectedTransaction: Partial<TransactionFacade> | undefined;
  transactionTableOptions: Options = new Options({
    debug: 'merchant-transactions',
    selectAction: 'popup',
    filterable: true,
  });

  allowMetrics = true;

  constructor(access: AccessManager) {
    this.tableView = new TableView(TransactionTableViewComponent);

    access
      .getUserAccess([AccessManager.AUTH_DASHBOARD_METRICS])
      .then((accessRecord) => {
        this.allowMetrics = accessRecord[AccessManager.AUTH_DASHBOARD_METRICS];
      });
  }

  ngAfterViewInit() {
    if (this.merchantId) {
      this.transactionTableOptions.merchantId = this.merchantId;
      if (this.numberOfLocationMIDs == 1 || this.hideMID) {
        this.transactionTableOptions.hiddenFields = ['MID'];
      }

      this.transactionsTableControl?.setOptions(this.transactionTableOptions);
    }
  }
}
